<template>
	<div class="login-page">
		<div class="logo">
			<img class="logo" src="/images/logo.png" alt="">
		</div>
		<div class="login">
			<div class="content">
				<h1>Log ind</h1>
				<p>Indtast brugernavn og adgangskode for at logge ind.</p>
				<div class="form">
					<input type="email" placeholder="Brugernavn" :value="entity.username" @input="entity.username = $event.target.value">
					<input type="password" placeholder="Adgangskode" @input="entity.password = $event.target.value">
				</div>
				<div class="tools">

				</div>
				<div class="button" @click="login">
					Log ind
				</div>
				<p v-if="error" class="error">{{ error }}</p>
				<div class="moovr">
					<div class="copyright"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				entity: {
					customer_id: 1,
					username: '',
					password: ''
				},
				error: null
			};
		},
		methods: {
			login() {
				//this.error = 'Der skete en fejl under login';

				this.error = null;

				var self = this;

				this.axios
					.post('/login/', this.entity)
					.then(async function (r) {
						console.log(r);	
						self.$store.state.auth = r.data;
						localStorage.setItem('auth', r.data);

						const user = (await self.axios.get(`/users/me`)).data;

						self.$router.replace('/da');							

						self.$store.commit('user', user);
						//self.$store.commit('department', {});

						console.log(self.$store.state);	
					}, function (err) {
						console.log('ERROR');
						console.log(err.response);
						var r = err.response;

						if (r.status == 422) {
							self.error = r.data;
						} else if (r.status == 401) {
							self.error = r.data.message;
						} else {
							self.error = 'Der opstod en systemfejl';
						}
					});	
			}
		}
	}
</script>

<style lang="scss" scoped>
	.login-page {
		background-color: #45a9f2;

		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 1fr 400px;

		background: url('/images/background.jpg') no-repeat left center;
		background-size: cover;

		& > .logo {
			position: relative;

			& > .logo {
				position: absolute;
				left: 40px;
				bottom: 40px;
				width: 200px;
			}
		}

		& > .login {
			background-color: white;

			& > .content {
				padding: 150px 55px 0 55px;
				position: relative;
				height: 100%;

				& > h1 {
					font-size: 24px;
				}

				& > p {
					margin-top: 20px;
					font-size: 12px;
					color: rgb(150, 150, 150);

					&.error {
						color: #f7223f;
					}
				}

				& > .form {
					margin-top: 30px;

					& > input {
						-webkit-appearance: none;
						-moz-appearance: none;
						appearance: none;

						margin-top: 20px;

						border: 1px solid rgb(209, 209, 209);
						border-radius: 3px;
						font-size: 12px;
						font-weight: 100;
						width: 100%;
						height: 30px;
						line-height: 30px;
						padding: 0 10px 0 10px;

						&::placeholder {
							color: rgb(168, 168, 168);
						}
					}
				}

				& > .button {
					margin-top: 20px;
					width: 100%;
					text-align: center;
					border-radius: 3px;
				}

				& > .moovr {
					position: absolute;
					left: 0;
					bottom: 0;
					width: 290px;
					left: 55px;
					bottom: 55px;
					text-align: center;

					& > .logo {
						width: 60%;
						margin-bottom: 20px;
					}

					& > .copyright {
						font-size: 12px;
					}
				}
			}
		}
	}

	@media only screen and (max-width: 400px) {
		.login-page {
			& > .login {
				width: 100vw;

				& > .content {
					
				}
			}
		}
	}
</style>